// LandingPage — T-011. Composition of the six landing sections in the
// order the design system prescribes.

import type { JSX } from "react";
import { LandingHeader } from "./LandingHeader";
import { HeroSection } from "./HeroSection";
import { BigSixGrid } from "./BigSixGrid";
import { FeatureRow } from "./FeatureRow";
import { CommunitySection } from "./CommunitySection";
import { CoachCallout } from "./CoachCallout";
import { LandingFooter } from "./LandingFooter";

export default function LandingPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-[var(--color-void)] text-[var(--color-ink)]">
      <LandingHeader />
      <main id="landing">
        <HeroSection />
        <BigSixGrid />
        <FeatureRow />
        <CommunitySection />
        <CoachCallout />
      </main>
      <LandingFooter />
    </div>
  );
}
